import React from 'react';
import { Body, Box, Heading, Stack } from '@hover/blueprint';
import type { StackProps } from '@hover/blueprint';

export type Advantage = { title: string; body: string };

interface IAdvantagesProps extends StackProps {
  items: Advantage[];
}

const Advantages = ({ items, ...stackProps }: IAdvantagesProps) => (
  <Stack
    {...stackProps}
    direction={{ base: 'column', desktop: 'row' }}
    gap={12}
    justifyContent="space-between"
    w="100%"
    px={{ base: 6, desktop: 20 }}
  >
    {items.map(item => (
      <Box
        key={item.title}
        px={12}
        py={8}
        d="block"
        textAlign="center"
        bgColor="neutral.50"
      >
        <Heading size={{ base: 300, tablet: 400, desktop: 500 }} sx={{ mb: 0 }}>
          {item.title}
        </Heading>
        <Body>{item.body}</Body>
      </Box>
    ))}
  </Stack>
);

export default Advantages;
